import React from "react";
import { connect } from "react-redux";
import { Popup, Button, ValidationGroup } from "devextreme-react";
import TextField from "../../../../Shared/fields/TextField";
import SelectField from "../../../../Shared/fields/SelectField";
import {
  openCloseModalEditarPrestacionesSel, doAddPrestacion, doUpdatePrestacion,
  setPrestacionSel, openCloseModalDesactivarPrestacionSel,
} from "./action";
import SwitchField from "../../../../Shared/fields/SwitchField";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";

class ModalEditar extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      activoPrev: null,
    };
  }

  componentDidUpdate = (preProps) => {
    if (!preProps.isOpenModalEditarPrestacion && this.props.isOpenModalEditarPrestacion) {
      const { prestacion } = this.props;
      this.setState({ activoPrev: prestacion.Activo });
    }
  }

  handleChange = (e) => {
    const newPrestacion = { ...this.props.prestacion };
    if (e.element.id === "PrestacionesStatus") {
      e.element.id = "Status";
    }
    if (e.element.id === "PrestacionesExamTypeId") {
      e.element.id = "ExamTypeId";
    }
    newPrestacion[e.element.id] = e.value;
    this.props.dispatch(setPrestacionSel(newPrestacion));
  }

  handleCancel = () => {
    this.props.dispatch(openCloseModalEditarPrestacionesSel(false, {}, false));
  }

  handleSave = (params) => {
    const result = params.validationGroup.validate();
    if (result.isValid) {
      if (this.props.isNewPrestacion) {
        this.props.dispatch(doAddPrestacion(this.props.prestacion));
      } else if (this.state.activoPrev && !this.props.prestacion.Activo) {
        this.props.dispatch(openCloseModalDesactivarPrestacionSel(true, this.props.prestacion));
      } else {
        this.props.dispatch(doUpdatePrestacion(this.props.prestacion));
      }
    }
  }

  render() {
    const { prestacion } = this.props;
    let title = "Editar prestación";
    let saveText = "Guardar";

    if (this.props.isNewPrestacion) {
      title = "Agregar prestación";
      saveText = "Agregar";
    }
    return (
      <Popup
        title={title}
        dragEnabled={false}
        onHiding={this.handleCancel}
        visible={this.props.isOpenModalEditarPrestacion && !this.props.isOpenModalDesactivarPrestacion}
        width={700}
        height={450}
        contentComponent={() => (
          <div className="dense-form" style={{ marginTop: -20 }}>
            {this.props.isLoading && <LoadingOverlay />}
            <ValidationGroup >
              <TextField
                id="Description"
                label="Examen"
                maxLength={60}
                value={prestacion.Description}
                onChange={this.handleChange}
              />

              <SelectField
                id="PrestacionesExamTypeId"
                label="Tipo"
                value={prestacion.ExamTypeId}
                onChange={this.handleChange}
                items={this.props.tiposPrestacion}
                displayExpr="Name"
                valueExpr="Id"
              />

              <SwitchField
                id="PrestacionesStatus"
                label="Activado"
                value={!!prestacion.Status}
                onChange={this.handleChange}
                switchedOffText="No"
                switchedOnText="Si"
                visible
              />

              <TextField
                label="Código SAP"
                id="Code"
                maxLength={25}
                value={prestacion.Code}
                onValueChanged={this.handleChange}
              />

              <div className="button-row">
                <div>
                  <Button text="Cancelar" style={{ marginRight: 5 }} onClick={this.handleCancel} />
                </div>
                <div>
                  <Button text={saveText} type="success" onClick={this.handleSave} useSubmitBehavior />
                </div>
              </div>
            </ValidationGroup>
          </div>
        )}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  isOpenModalDesactivarPrestacion: state.mantenedorPrestacionesSel.isOpenModalDesactivarPrestacion,
  isOpenModalEditarPrestacion: state.mantenedorPrestacionesSel.isOpenModalEditarPrestacion,
  prestacion: state.mantenedorPrestacionesSel.prestacion,
  tiposPrestacion: state.mantenedorPrestacionesSel.tiposPrestacion,
  isNewPrestacion: state.mantenedorPrestacionesSel.isNewPrestacion,
  isLoading: state.mantenedorPrestacionesSel.isLoading,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalEditar);
